(function ($) {
  Drupal.behaviors.contentFilterSetPrimaryV1 = {
    attached: false,
    nodes: {},
    selectors: {
      modules: '.js-content-filter-set-primary-v1',
      filters: '.js-content-filters',
      filterListSeparatorPrev: '.js-content-filter-set-primary-list-separator-prev',
      filterListSeparatorNext: '.js-content-filter-set-primary-list-separator-next',
    },
    attach: function (context) {
      var self = this;
      var $modules = $(self.selectors.modules, context);

      if (self.attached) {
        return;
      }
      self.attached = true;

      $modules.each(function () {
        var $module = $(this);
        self.setup($module);
      });
    },
    setup: function ($module) {
      var self = this;
      
      self.getDom($module);
      self.setEvents($module);
    },
    getDom: function ($module) {
      var self = this;

      $module.nodes = {};
      $module.nodes.$filters = $(self.selectors.filters, $module);
      $module.nodes.$filterListSeparatorPrev = $(self.selectors.filterListSeparatorPrev, $module);
      $module.nodes.$filterListSeparatorNext = $(self.selectors.filterListSeparatorNext, $module);
    },
    setEvents: function ($module) {
      var self = this;
      var filterListScrollActive = false;
      var filterListScrollStartX = 0;
      var filterListScrollLeft = 0;
      
      $module.nodes.$filters.once().on('mousedown', function (event) {
          filterListScrollActive = true;
          filterListScrollStartX = event.pageX - $module.nodes.$filters[0].offsetLeft;
          filterListScrollLeft = $module.nodes.$filters[0].scrollLeft;
      }).on('mouseleave mouseup', function () {
          filterListScrollActive = false;
      }).on('mousemove', function (event) {
          if (!filterListScrollActive) {
            return;
          }
          event.preventDefault();
          var offsetLeft = event.pageX - $module.nodes.$filters[0].offsetLeft;
          $module.nodes.$filters[0].scrollLeft = filterListScrollLeft - offsetLeft + filterListScrollStartX;
          self.toggleFilterListSeparators($module);
      }).on('mousemove touchmove scroll', function () {
          self.toggleFilterListSeparators($module);
      });
    },
    toggleFilterListSeparators: function ($module) {
      if ($module.nodes.$filters.length < 1) {
        return;
      }
      var filterListWidth = Math.ceil($module.nodes.$filters[0].getBoundingClientRect().width);
      if ($module.nodes.$filters[0].scrollLeft > 0) {
        $module.nodes.$filterListSeparatorPrev.removeClass('hidden');
      } else {
        $module.nodes.$filterListSeparatorPrev.addClass('hidden');
      }
      if (parseInt($module.nodes.$filters[0].scrollWidth - $module.nodes.$filters[0].scrollLeft) > filterListWidth) {
        $module.nodes.$filterListSeparatorNext.removeClass('hidden');
      } else {
        $module.nodes.$filterListSeparatorNext.addClass('hidden');
      }
    },
  };
})(jQuery);
